module.exports = __webpack_public_path__ + "static/media/testcafelogo.7540fedc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/testcafelogo.png
// module id = 822
// module chunks = 0